export default __webpack_public_path__ + "static/media/harkey-house.7fedc5fc.jpg";